module.exports = __webpack_public_path__ + "img/orchid-alt.ee1f124a.png";